/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Existing_WaitingInputs */

const en_existing_waiting = /** @type {(inputs: Existing_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting for the agent…`)
};

const id_existing_waiting = /** @type {(inputs: Existing_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menunggu agent…`)
};

/**
* | output |
* | --- |
* | "Waiting for the agent…" |
*
* @param {Existing_WaitingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const existing_waiting = /** @type {((inputs?: Existing_WaitingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Existing_WaitingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_existing_waiting(inputs)
	return en_existing_waiting(inputs)
});